/* CS winkelwagenpagina: stepper en verwijderen via de Cart API, daarna
   verversen via de Section Rendering API. Zelfde patroon als cs-cart-drawer.js
   (serieel via één queue), maar zonder dialog: de pagina zelf is de cart.
   Naast de pagina worden ook het cart-icoon en de drawer-inhoud ververst,
   zodat de badge en een later geopende drawer meteen kloppen. */
(() => {
  if (window.__csCartPageInit) return;
  window.__csCartPageInit = true;

  const wortel = () => document.querySelector('[data-cs-cart-page]');
  if (!wortel()) return;

  const routes = window.routes || {};
  const cartUrl = routes.cart_url || '/cart';
  const changeUrl = (routes.cart_change_url || '/cart/change') + '.js';

  /* Sectie-id's: de pagina komt uit templates/cart.json (sleutel
     cs-cart-page), de andere twee zijn statische secties uit theme.liquid. */
  const sectieIds = 'cs-cart-page,cart-icon-bubble,cs-cart-drawer';

  const FETCH_MS = 15000;
  const fetchMetGrens = (url, opties) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), FETCH_MS);
    return fetch(url, Object.assign({}, opties, { signal: controller.signal })).finally(() => clearTimeout(timer));
  };

  const fetchCart = () =>
    fetchMetGrens(`${cartUrl}.js`, { headers: { Accept: 'application/json' } }).then((r) => {
      if (!r.ok) throw new Error(`cart.js ${r.status}`);
      return r.json();
    });

  const post = (url, payload) =>
    fetchMetGrens(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then((r) => {
      if (!r.ok) {
        return r.json().catch(() => ({})).then((data) => {
          throw new Error(data.description || data.message || `HTTP ${r.status}`);
        });
      }
      return r.json();
    });

  /* Geen Accept: application/json meesturen; Shopify geeft /cart dan de
     AJAX-cart-JSON terug in plaats van de sections-map. */
  const ververs = async () => {
    const respons = await fetchMetGrens(`${cartUrl}?sections=${sectieIds}`);
    if (!respons.ok) throw new Error(`sections ${respons.status}`);
    const secties = await respons.json();
    const parser = new DOMParser();

    const pagina = wortel();
    const paginaHtml = secties['cs-cart-page'];
    if (pagina && paginaHtml) {
      const nieuw = parser.parseFromString(paginaHtml, 'text/html').querySelector('[data-cs-cart-page]');
      if (nieuw) {
        const focusId = document.activeElement && document.activeElement.dataset
          ? document.activeElement.dataset.csFocus
          : null;
        pagina.dataset.csTeller = nieuw.dataset.csTeller || '0';
        pagina.innerHTML = nieuw.innerHTML;
        if (focusId) {
          const doel = pagina.querySelector(`[data-cs-focus="${focusId}"]`);
          if (doel && !doel.disabled) doel.focus();
          else {
            const titel = pagina.querySelector('.cs-cart-page__titel');
            if (titel) {
              titel.setAttribute('tabindex', '-1');
              titel.focus();
            }
          }
        }
        const status = pagina.querySelector('[data-cs-cp-status]');
        if (status) {
          const t = pagina.dataset.csTeller;
          status.textContent = `Winkelwagen bijgewerkt: ${t} ${t === '1' ? 'artikel' : 'artikelen'}.`;
        }
      }
    }

    const bubbleHtml = secties['cart-icon-bubble'];
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubbleHtml && bubble) {
      const wrapper = parser.parseFromString(bubbleHtml, 'text/html').querySelector('.shopify-section');
      if (wrapper) bubble.innerHTML = wrapper.innerHTML;
    }

    const drawerHtml = secties['cs-cart-drawer'];
    const drawerInner = document.querySelector('[data-cs-drawer-inner]');
    if (drawerHtml && drawerInner) {
      const nieuw = parser.parseFromString(drawerHtml, 'text/html').querySelector('[data-cs-drawer-inner]');
      if (nieuw) {
        if (nieuw.dataset.csTeller !== undefined) drawerInner.dataset.csTeller = nieuw.dataset.csTeller;
        drawerInner.innerHTML = nieuw.innerHTML;
      }
    }

    document.dispatchEvent(new CustomEvent('cs:cart:ververst'));
  };

  let foutTimer = 0;
  const toonFout = () => {
    const w = wortel();
    const el = w ? w.querySelector('[data-cs-cp-fout]') : null;
    if (!w || !el) return;
    el.textContent = w.dataset.foutTekst || 'Er ging iets mis. Probeer het opnieuw.';
    el.hidden = false;
    clearTimeout(foutTimer);
    foutTimer = setTimeout(() => {
      el.hidden = true;
    }, 5000);
  };

  const staat = { queue: Promise.resolve(), busy: 0 };
  const inQueue = (taak) => {
    staat.busy += 1;
    const w = wortel();
    if (w) w.setAttribute('aria-busy', 'true');
    staat.queue = staat.queue
      .then(taak)
      .catch((fout) => {
        console.error('CS cart page:', fout);
        toonFout();
        return ververs().catch(() => {});
      })
      .finally(() => {
        staat.busy -= 1;
        if (staat.busy > 0) return;
        const wk = wortel();
        if (wk) wk.removeAttribute('aria-busy');
      });
    return staat.queue;
  };

  /* Cadeau (slaapmasker bij 3 verpakkingen) gelijktrekken na elke wijziging;
     de logica en de instellingen zitten in de cart drawer, die op elke pagina
     staat. change.js geeft de verse cart terug, dus geen extra fetch. */
  const cadeauSync = async (cart) => {
    if (!window.CSCart || typeof window.CSCart.cadeauSync !== 'function') return;
    try {
      await window.CSCart.cadeauSync(cart);
    } catch (fout) {
      console.warn('CS cart page: cadeau', fout);
    }
  };

  document.addEventListener('click', (event) => {
    const el = event.target instanceof Element ? event.target : null;
    if (!el || !el.closest('[data-cs-cart-page]')) return;

    const stap = el.closest('[data-cs-cp-plus], [data-cs-cp-min]');
    if (stap && !stap.disabled) {
      const key = stap.dataset.key;
      const richting = stap.hasAttribute('data-cs-cp-plus') ? 1 : -1;
      inQueue(async () => {
        const cart = await fetchCart();
        const regel = (cart.items || []).find((i) => i.key === key);
        if (!regel) return;
        const nieuw = regel.quantity + richting;
        if (nieuw < 1) return;
        const na = await post(changeUrl, { id: key, quantity: nieuw });
        await cadeauSync(na);
        await ververs();
      });
      return;
    }

    const verwijder = el.closest('[data-cs-cp-verwijder]');
    if (verwijder) {
      const key = verwijder.dataset.key;
      inQueue(async () => {
        const cart = await fetchCart();
        const regel = (cart.items || []).find((i) => i.key === key);
        if (regel) {
          const na = await post(changeUrl, { id: key, quantity: 0 });
          await cadeauSync(na);
        }
        await ververs();
      });
    }
  });

  /* De drawer kan op deze pagina ook open; na een wijziging daar de pagina
     stil bijwerken zodat beide hetzelfde tonen. Eigen verversingen sturen
     hetzelfde event, vandaar de guard op de queue. */
  document.addEventListener('cs:cart:ververst', () => {
    if (staat.busy > 0) return;
    const w = wortel();
    if (!w) return;
    /* Alleen bijwerken als de teller afwijkt van wat de drawer nu zegt. */
    const drawerInner = document.querySelector('[data-cs-drawer-inner]');
    if (!drawerInner || drawerInner.dataset.csTeller === undefined) return;
    if (drawerInner.dataset.csTeller === w.dataset.csTeller) return;
    inQueue(ververs);
  });

  /* bfcache: de cart kan op een andere pagina gewijzigd zijn. */
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) inQueue(ververs);
  });
})();
